import { AiAssist } from "@aircall/react-icons";

import { NoDataBanner } from "@/components/NoDataBanner/NoDataBanner";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const MOCK_SUMMARY =
  "The prospect is evaluating a migration from their legacy phone system and is most concerned about call quality and onboarding time. The team agreed to schedule a technical deep-dive with their IT lead next week.";

function Header() {
  return (
    <div className="flex items-center gap-2">
      <p className="text-lg font-medium">Summary</p>
      <AiAssist className="size-4" />
    </div>
  );
}

function WithSummary() {
  return (
    <div className="flex flex-col gap-4">
      <Header />
      <p className="text-sm font-normal" data-test="call-context-summary-text">
        {MOCK_SUMMARY}
      </p>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="flex flex-col gap-4">
      <Header />
      <NoDataBanner
        text="No summary was generated for this call"
        data-test="no-summary-generated"
      />
    </div>
  );
}

export function PlaygroundSectionSummary() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>With summary</PlaygroundSubSectionTitle>
        <WithSummary />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Empty state</PlaygroundSubSectionTitle>
        <EmptyState />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
